import { ADOBE_AMOUNT, ADOBE_REVERSE_VAT } from "../../adobe.js";
import { formatAmount } from "../../formatAmount.js";
import { Template } from "../../template/Template.js";
import { prefillTemplate } from "../../template/prefillTemplate.js";
import { INCOMING_EU_INVOICE } from "./IncomingEuInvoice.js";

export const ADOBE_INVOICE: Template = prefillTemplate(
  INCOMING_EU_INVOICE,
  "dcb01987-1c78-4506-a1c5-7046fd2dce83",
  "Adobe arve (Lightroom)",
  [
    {
      name: "Title",
      value: "Adobe arve"
    }
  ],
  [
    {
      name: "Expense amount",
      value: formatAmount(ADOBE_AMOUNT)
    },
    {
      name: "Reverse VAT",
      value: formatAmount(ADOBE_REVERSE_VAT)
    }
  ]
);
